import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ActiveSideMenuState {
  isToggleSideMenu: boolean;
}

const initialState: ActiveSideMenuState = {
  isToggleSideMenu: false,
};

const activeSideMenuSlice = createSlice({
  name: 'activeSideMenu',
  initialState,
  reducers: {
    setToggleSideMenu: (
      state: ActiveSideMenuState,
      action: PayloadAction<boolean>
    ) => {
      state.isToggleSideMenu = action.payload;
    },
  },
});

const { actions } = activeSideMenuSlice;

export const activeSideMenuActions = {
  ...actions,
};

export default activeSideMenuSlice;
